export function createGenderLabel(t, value) {
    return t(`common:gender.${value}`);
}
export function getStreetNumberComposite(street, houseNumber, staircase, doorNumber) {
    return ((street || '') +
        (houseNumber ? ` ${houseNumber}` : '') +
        (staircase ? `/${staircase}` : '') +
        (doorNumber ? `/${doorNumber}` : ''));
}
